import c from '@circuitid/common';
import store from '@/store';
import { router, route } from '@/core/helpers/functions.js';

export const faxAccountFormatter = (d: any) => {
  if (c.arrayEmpty(d)) return d;

  d.link = '/faxaccounts/' + d._id + '/all';
  d.show = true;
  d.items = [
    {
      name: d.name,
      _id: d._id,
      badge: 'secondary',
    },
  ];

  d.rightContent = '';

  return d;
};

export const loadFirstAccount = (force = false) => {
  if (!force && !route.name.includes('fax-accounts-')) return;

  if (c.arrayEmpty(store.getters.faxaccountData)) {
    router.push({ path: '/faxaccounts/welcome/dashboard' });
    return;
  }

  const id = router.currentRoute.value.params.id;
  const index = c.inArray('_id', id, store.getters.faxaccountData);

  if (
    c.isValidObjectId(id) &&
    typeof index === 'number' &&
    !c.arrayEmpty(store.getters.faxaccountData[index])
  )
    return;

  // Route to first fax account if no valid last page visited
  for (const i in store.getters.faxaccountData)
    if (
      !c.arrayEmpty(store.getters.faxaccountData[i]) &&
      c.isValidObjectId(store.getters.faxaccountData[i]._id)
    ) {
      router.push({
        path: '/faxaccounts/' + store.getters.faxaccountData[i]._id + '/all',
      });
      return;
    }
};

export const loadFaxAccount = (id: string) => {
  if (
    !c.isValidObjectId(id) ||
    !c.toLower(route.path).includes('/faxaccounts/')
  )
    return;

  const service = 'faxaccounts';
  const objectName = 'faxaccount';

  store.dispatch('setValue', {
    key: objectName,
    value: {},
  });

  store
    .dispatch('getObject', {
      service: service,
      objectName: objectName,
      id: id,
      query: {
        stats: 1,
      },
    })
    .then((r) => {
      r.total = c.getInt(r.allowedFaxInCount) + c.getInt(r.allowedFaxOutCount);
      r.remaining =
        c.getInt(r.remainingFaxInCount) + c.getInt(r.remainingFaxOutCount);

      r.used = c.getInt(r.total - r.remaining);

      r.percentOfTotal = c.getFloat(
        (c.getFloat(r.used / r.total) * 100).toFixed(2),
      );

      store.dispatch('setValue', {
        key: objectName,
        value: r,
      });

      if (r.payAsYouGo) {
        store
          .dispatch('getObject', {
            service: 'customers',
            objectName: 'customer',
            noSetData: true,
            id: store.getters.customerId,
          })
          .then((r) => {
            if (c.objectEmpty(r)) return;

            store.dispatch('setValue', {
              key: 'faxCredit',
              value: r.faxCredit || 0,
            });
          });
      }
    });
};
